import React, { useEffect } from 'react';

import authService from 'src/auth/authService';

/**
 * A blank page whose sole purpose is redirecting to the login page.
 */
const AuthLoginPage: React.FC = () => {
	useEffect(() => {
		authService.signIn();
	}, []);

	return <></>;
};

export default AuthLoginPage;
